var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchCategoryBusinessApplications16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture-Category/16/Business-Applications_16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Business-Applications_16.svg"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0816",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5252",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-Category/16/Business-Applications_16",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linear-gradient-aws/Category-Icons/Arch-Category_16/Arch-Category_Business-Applications_16.svg)",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "#879196-Border-Copy-5",
    stroke: "#879196",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Category/16/Business-Application_16",
    transform: "translate(9.000000, 8.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1915021,15 L1.80850205,15 L1.30850205,14 L13.6915021,14 L13.1915021,15 Z M2.00050205,7.214 C2.00050205,7.096 2.09150205,7 2.20550205,7 L3.00050205,7 L3.00050205,13 L2.00050205,13 L2.00050205,7.214 Z M4.00050205,6 L4.50050205,6 C4.77650205,6 5.00050205,5.776 5.00050205,5.5 L5.00050205,4 L6.00050205,4 L6.00050205,13 L4.00050205,13 L4.00050205,6 Z M7.00050205,13 L8.00050205,13 L8.00050205,3 L7.00050205,3 L7.00050205,13 Z M9.00050205,4 L10.0005021,4 L10.0005021,5.5 C10.0005021,5.776 10.2235021,6 10.5005021,6 L11.0005021,6 L11.0005021,13 L9.00050205,13 L9.00050205,4 Z M12.0005021,7 L12.7865021,7 C12.9045021,7 13.0005021,7.096 13.0005021,7.214 L13.0005021,13 L12.0005021,13 L12.0005021,7 Z M14.9255021,13.237 C14.8345021,13.09 14.6725021,13 14.5005021,13 L14.0005021,13 L14.0005021,7.214 C14.0005021,6.545 13.4555021,6 12.7865021,6 L12.0005021,6 L12.0005021,5.5 C12.0005021,5.224 11.7325021,5 11.4565021,5 L11.0005021,5 L11.0005021,3.5 C11.0005021,3.224 10.7765021,3 10.5005021,3 L9.00050205,3 L9.00050205,2.5 C9.00050205,2.224 8.77650205,2 8.50050205,2 L8.00050205,2 L8.00050205,0 L7.00050205,0 L7.00050205,2 L6.50050205,2 C6.22350205,2 6.00050205,2.224 6.00050205,2.5 L6.00050205,3 L4.50050205,3 C4.22350205,3 4.00050205,3.224 4.00050205,3.5 L4.00050205,5 L3.54450205,5 C3.26750205,5 3.04450205,5.224 3.04450205,5.5 L3.04450205,6 L2.21350205,6 C1.54550205,6 1.00050205,6.545 1.00050205,7.214 L1.00050205,13 L0.500502054,13 C0.327502054,13 0.166502054,13.09 0.0745020543,13.237 C-0.0164979457,13.385 -0.0244979457,13.569 0.0525020543,13.724 L1.05250205,15.724 C1.13750205,15.893 1.31050205,16 1.50050205,16 L13.5005021,16 C13.6895021,16 13.8625021,15.893 13.9475021,15.724 L14.9475021,13.724 C15.0245021,13.569 15.0165021,13.385 14.9255021,13.237 L14.9255021,13.237 Z",
    id: "Business-Application_Category-Icon_16_Squid--"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchCategoryBusinessApplications16);
export default __webpack_public_path__ + "static/media/Arch-Category_Business-Applications_16.2041839bbda5ac2bdcff0c215e4fa50d.svg";
export { ForwardRef as ReactComponent };